import { createFileRoute } from "@tanstack/react-router";

import { ShowContestant } from "../features/show/ShowContestant";

/** The buzzer. The race takes the press, the seat board the box and the name, the stage is read. */
export const Route = createFileRoute("/show/contestant/$raceMount/$seatMount/$stageMount")({
  component: ContestantCanvas,
});

function ContestantCanvas() {
  const { raceMount, seatMount, stageMount } = Route.useParams();
  return (
    <main>
      <ShowContestant raceMount={raceMount} seatMount={seatMount} stageMount={stageMount} />
    </main>
  );
}
